import React from 'react';
import Script from 'next/script';
import type { ProjectData } from '../../data/project-data';

interface ProjectStructuredDataProperties {
  project: ProjectData;
}

function ProjectStructuredData({ project }: ProjectStructuredDataProperties) {
  const slug = project.urlSlug;
  const domain = process.env.NEXT_PUBLIC_DOMAIN || 'https://www.cornerstonehomesandproperties.com';

  const breadcrumbSchema = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      {
        '@type': 'ListItem',
        position: 1,
        name: 'Home',
        item: domain,
      },
      {
        '@type': 'ListItem',
        position: 2,
        name: 'Projects',
        item: `${domain}/projects`,
      },
      {
        '@type': 'ListItem',
        position: 3,
        name: project.name,
        item: `${domain}/projects/${slug}`,
      },
    ],
  };

  const listingSchema: Record<string, unknown> = {
    '@context': 'https://schema.org',
    '@type': 'RealEstateListing',
    name: `${project.name} - Custom Home by Cornerstone Homes`,
    description: project.metaDescription,
    url: `${domain}/projects/${slug}`,
    address: {
      '@type': 'PostalAddress',
      addressLocality: 'Claremore',
      addressRegion: 'OK',
      addressCountry: 'US',
    },
  };

  if (project.sqft) {
    listingSchema.floorSize = {
      '@type': 'QuantitativeValue',
      value: project.sqft.replace(/,/g, ''),
      unitCode: 'FTK',
    };
  }

  if (project.beds) {
    listingSchema.numberOfBedrooms = project.beds;
  }

  if (project.baths) {
    listingSchema.numberOfBathroomsTotal = project.baths;
  }

  return (
    <>
      <Script
        id={`breadcrumb-schema-${slug}`}
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(breadcrumbSchema) }}
      />
      <Script
        id={`listing-schema-${slug}`}
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(listingSchema) }}
      />
    </>
  );
}

export default ProjectStructuredData;
